/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(investimento) {
        return axiosJwt.delete(`${api}/contratos/${investimento.contratoId}/investimentos-previstos/${investimento.idInvestimentoPrevistoContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(investimento) {
        return axiosJwt.post(`${api}/contratos/${investimento.contratoId}/investimentos-previstos`, investimento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(contratoId, idInvestimentoPrevistoContrato, investimento) {
        return axiosJwt.put(`${api}/contratos/${contratoId}/investimentos-previstos/${idInvestimentoPrevistoContrato}`, investimento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterInvestimentos(contratoId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/investimentos-previstos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterInvestimento(contratoId, idInvestimentoPrevistoContrato) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/investimentos-previstos/${idInvestimentoPrevistoContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
